import axios from "axios";
import { ACCOUNTS_URL, ACCOUNTS_TYPES_URL } from "../../../../../constants/config";

export function getAllAccounts(queryParams) {
  const isActiveParam = queryParams?.is_active || "";
  const sortBy = queryParams?.sort_by || `${queryParams?.sortField || "created_at"}:${queryParams?.sortOrder || "desc"}`;
  const url = `${ACCOUNTS_URL}/accounts/list?search_key=${queryParams?.searchText || ""}&page=${
    queryParams?.pageNumber || 1
  }&page_size=${queryParams?.pageSize || 20}&sort_by=${sortBy}&type_ids=${queryParams?.type_ids || ""}&code=${queryParams?.code || ""}&is_active=${isActiveParam}`;
  return axios.get(url);
}

// Where each customer tender is booked: tenant mapping, system default and the effective account.
export function getTenderRouting() {
  return axios.get(`${ACCOUNTS_URL}/accounts/tender-routing`);
}

export function createAccounts(account) {
  return axios.post(`${ACCOUNTS_URL}/accounts`, account);
}

export function updateAccount(accountId, account) {
  return axios.put(`${ACCOUNTS_URL}/accounts/${accountId}`, account);
}

export function getAccountById(accountId) {
  return axios.get(`${ACCOUNTS_URL}/accounts/${accountId}`);
}

export function getAccountTransactions(accountId, queryParams = {}) {
  const params = new URLSearchParams({
    page: queryParams?.page || queryParams?.pageNumber || 1,
    page_size: queryParams?.page_size || queryParams?.pageSize || 20,
    start_date: queryParams?.start_date || "",
    end_date: queryParams?.end_date || "",
    search_key: queryParams?.search_key || queryParams?.searchText || "",
    status: queryParams?.status || "",
  });

  return axios.get(`${ACCOUNTS_URL}/accounts/${accountId}/transactions?${params.toString()}`);
}

export function exportAccountTransactions(accountId, queryParams = {}, format = "csv") {
  const params = new URLSearchParams({
    start_date: queryParams?.start_date || "",
    end_date: queryParams?.end_date || "",
    search_key: queryParams?.search_key || queryParams?.searchText || "",
    status: queryParams?.status || "",
    format,
  });

  return axios.get(`${ACCOUNTS_URL}/accounts/${accountId}/transactions/export?${params.toString()}`, {
    responseType: "blob",
  });
}

export function deleteAccount(accountId) {
  return axios.delete(`${ACCOUNTS_URL}/accounts/${accountId}`);
}

export function fetchAllAccountTypes() {
  return axios.get(`${ACCOUNTS_TYPES_URL}/tree`);
}

export function fetchAllAccountTypesList(params) {
  return axios.get(`${ACCOUNTS_TYPES_URL}/list?search_key=${params?.search_key || ""}`);
}

export function fetchParentAccounts(account_type_id) {
  return axios.get(`${ACCOUNTS_URL}/accounts/parent-accounts?account_type_id=${account_type_id}`);
}

export function toggleAccountStatus(accountId, isActive = null) {
  const payload = {};
  if (isActive !== null) {
    payload.is_active = isActive;
  }
  return axios.patch(`${ACCOUNTS_URL}/accounts/${accountId}/toggle-status`, payload);
}

export function bulkToggleAccountStatus(accountIds, isActive = null) {
  const payload = { account_ids: accountIds };
  if (isActive !== null) {
    payload.is_active = isActive;
  }
  return axios.patch(`${ACCOUNTS_URL}/accounts/bulk-toggle-status`, payload);
}
